.closeButton {
  color: var(--tuna-palette-grey-500);
  z-index: 1;
}
